module.exports = __webpack_public_path__ + "img/8.0fd876ea.jpg";